import { GRUPOS_MODULOS } from '../data';
import PlataformaGrupoDestaque from './PlataformaGrupoDestaque';

export default function PlataformaModulos() {
  return (
    <section id="modulos" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            A jornada completa
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Quatro frentes, <span className="text-primary-600">um único lugar</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-foreground-600">
            Cada etapa do seu programa de incentivo em um ecossistema conectado — da decisão estratégica à
            premiação na ponta, sem fricção e sem planilha.
          </p>
        </div>

        {GRUPOS_MODULOS.map((grupo, index) => (
          <PlataformaGrupoDestaque key={grupo.id} grupo={grupo} reverse={index % 2 === 1} />
        ))}
      </div>
    </section>
  );
}